import { create } from 'zustand'

/**
 * A consulta sugerida pelo @DBA a caminho do editor SQL ("Aplicar no editor", spec
 * 2026-10-30-agente-dba §4.8).
 *
 * Uma frase: **guarda UMA entrega pendente (alvo e SQL) até o editor consumi-la**. Não executa
 * nada: o editor só põe o texto no campo, e quem roda é a pessoa, pelo fluxo de leitura ou de
 * escrita de sempre.
 *
 * Por que um store e não a seleção direto (`useDbSelection`): o editor zera instância, banco e
 * SQL quando o tenant muda — inclusive no PRIMEIRO render. Escrever a seleção antes de navegar
 * seria apagado por esse reset; o editor consome a entrega DEPOIS dele.
 */
export interface EntregaAoEditor {
  tenantId: number
  instancia: string
  banco: string | null
  sql: string
}

interface AplicarNoEditorState {
  pendente: EntregaAoEditor | null
  deixar: (e: EntregaAoEditor) => void
  /** Devolve a entrega se ela é deste tenant, e a apaga; senão `null` (e ela fica). */
  consumir: (tenantId: number | null | undefined) => EntregaAoEditor | null
}

export const useAplicarNoEditor = create<AplicarNoEditorState>((set, get) => ({
  pendente: null,
  deixar: (e) => set({ pendente: e }),
  consumir: (tenantId) => {
    const p = get().pendente
    if (!p || tenantId == null || p.tenantId !== tenantId) return null
    set({ pendente: null })
    return p
  },
}))
